<template>
  <div>
    <h5>Начисления по Пользователю:</h5>
    <!-- placementInfo: {{placementInfo}} -->
    <tableOperations :items="items"
      @update-operations-table="getItems( operationDefault.user )"
    />
    <b-button @click="getItems(operationDefault.user)">Обновить данные</b-button>

    <h5>Добавить начисление по задаче</h5>
    <div><addOperation
          v-if="operationDefault.dataReady"
          v-bind:operationDefault="operationDefault"
          mode="add"
          @update-operations-table="getItems( operationDefault.user )"
     /></div>
  </div>
</template>

<script>
import addOperation from '../components/addOperations.vue'
import tableOperations from '../components/tableOperations.vue'
export default {
  components: {
    addOperation,
    tableOperations
  },
    data() {
      return {
        placementInfo: 'placementInfo',
        operationDefault: null,
        operationDefault: {
          task: null,
          deal: null,
          user: null,
          contact: null,
          company: null,
          dataReady: false
        },
        items: [],
      }
  },
  async created() {
      this.placementInfo = BX24.placement.info()
      this.operationDefault.user = this.placementInfo.options.USER_ID

      // let result = await this.$store.dispatch ( 'getDealAndCompanyByTask', this.operationDefault.task, { root: true } );
      // this.operationDefault.deal = result[0]
      // this.operationDefault.company = result[1]
      this.operationDefault.dataReady = true

      this.getItems( this.operationDefault.user )
  },
  methods: {
    getItems ( user ) {
      // Фильтр на основе текущего места вызова, фильтрация по property
      let payload = {
            ENTITY: 'accrual',
            FILTER: {
              PROPERTY_USER: user
            },
      }
      this.$store.dispatch( 'getItems', payload, { root: true } )
      .then (result => {
          // console.dir(result);
          this.items = []
          result.map ( item => {
              this.items.push (
              {
                  'status': item.PROPERTY_VALUES.status,
                  'user': item.PROPERTY_VALUES.user,
                  'reference': item.PROPERTY_VALUES.reference,
                  'amount': item.PROPERTY_VALUES.amount,
                  'typeOfPayment': item.PROPERTY_VALUES.typeOfPayment,
                  'dataSort': item.PROPERTY_VALUES.dataSort,
                  'task': item.PROPERTY_VALUES.task,
                  'deal': item.PROPERTY_VALUES.deal,
                  'company': item.PROPERTY_VALUES.company,
                  'contact': item.PROPERTY_VALUES.contact,
                  'id': item.ID
              })

          })
      })
    }
  },
}
</script>

<style scoped>

</style>